import { LangCodeEnum } from 'shared/enums/LangCodeEnum';

export enum SubmitStatusEnum {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export type RespondentMetaDto = {
  preferredLanguage: LangCodeEnum | null;
  submitStatus?: SubmitStatusEnum | null;
};

export type RespondentMetaModel = {
  preferredLanguage: LangCodeEnum | null;
  submitStatus: SubmitStatusEnum | null;
};

export const mapRespondentMetaDtoToModel = (dto: RespondentMetaDto): RespondentMetaModel => {
  return {
    preferredLanguage: dto.preferredLanguage,
    submitStatus: dto.submitStatus ?? null,
  };
};
